import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'type',
        label: i18n.t('notification.type'),
    },
    {
        key: 'user',
        label: i18n.t('user._'),
    },
    {
        key: 'createdAt',
        label: i18n.t('attributes.sent_at'),
    },
    {
        key: 'content',
        label: i18n.t('notification.content'),
    },
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
]